import type { SupportComment, SupportMessage } from "@/types/support";

export type SupportConversationItem = {
  id: string;
  kind: "message" | "comment";
  content: string;
  createdAt: string;
  authorName: string;
  isFromCustomer: boolean;
  isInternal?: boolean;
};

export function buildSupportConversation(
  comments: SupportComment[] = [],
  messages: SupportMessage[] = [],
  options?: { includeInternal?: boolean; customerId?: string },
): SupportConversationItem[] {
  const customerId = options?.customerId;
  const items: SupportConversationItem[] = [];

  for (const comment of comments) {
    if (comment.isInternal && !options?.includeInternal) continue;
    items.push({
      id: `comment-${comment.id}`,
      kind: "comment",
      content: comment.content,
      createdAt: comment.createdAt,
      authorName: comment.authorName,
      isFromCustomer: customerId ? comment.authorId === customerId : false,
      isInternal: comment.isInternal,
    });
  }

  for (const message of messages) {
    items.push({
      id: `message-${message.id}`,
      kind: "message",
      content: message.content,
      createdAt: message.createdAt,
      authorName: message.senderName,
      isFromCustomer: message.senderType === "customer",
    });
  }

  return items.sort(
    (a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
  );
}
